import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { ImportSecurityModelsResultDialogComponent } from '@irb/irb-models/import-security-model-result-dialog/import-security-model-result-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ImportSecurityModelsResultGridLayoutService implements GridLayoutService<ImportSecurityModelsResultDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Name',            
            field: 'modelName',
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                text: (params: any) => {
                  return (params.value != null && params.value.length > 0);
              }
          },
            maxWidth: 200,
            width: 200
            
        },
        {
            headerName: 'Status',
            field: 'status',
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                text: (params: any) => {
                  return (params.value != null && params.value.length > 0);
              }
          },
          width: 235
        },
        {
            headerName: 'Action',
            field: 'action',
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                text: (params: any) => {
                  return (params.value != null && params.value.length > 0);
              }
          },
          maxWidth: 170,
          width: 170
        }];
    }
}
